export default "__VITE_PUBLIC_ASSET__6e40f3cb__"